import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-itfacility-revoke-checker',
  templateUrl: './itfacility-revoke-checker.component.html',
  styleUrls: ['./itfacility-revoke-checker.component.scss']
})
export class ITFacilityRevokeCheckerComponent implements OnInit {

  constructor(public appservice:AppService,public router:Router) { }
editEmployee(data){
  this.appservice.CheckerRevokeEdit=data;
  //console.log("the edit id",this.appservice.hrclosureeditid);
  this.router.navigate(['/home/CheckerRevokeReview'])
}
public RevokeGrid:any[]=[];
GetRevokedData(){
   this.RevokeGrid=[];
  this.appservice.getTable("api/Transaction/pr_Get_RevokeData_forChecker?id="+this.appservice.CheckerID).subscribe((res:any)=>{
    this.RevokeGrid=JSON.parse(res);
    //console.log("the values",this.hrclosuredata);
      });
}
GetOnboardingGrid(){
  this.appservice.Hrcloser_type="Onboarding";
  this.appservice.gethrclosuredata();
}
GetOffboardingGrid(){
  this.appservice.Hrcloser_type="Offboarding";
  this.appservice.GetOffboardingDetails();
}
  ngOnInit(): void {
    this.GetRevokedData()
  }

}
